export var AnimationDirection;
(function (AnimationDirection) {
  AnimationDirection[AnimationDirection["forward"] = 0] = "forward";
  AnimationDirection[AnimationDirection["backward"] = 1] = "backward";
})(AnimationDirection || (AnimationDirection = {}));